function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.16833 1.328H12.8452V1.94669H14.173V1.24139C14.1732 0.556915 13.6166 0 12.9325 0H9.08105C8.39691 0 7.84033 0.556915 7.84033 1.24139V1.94669H9.16833V1.328Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2396 7.20801H4.77396C4.43239 7.20801 4.1635 7.49939 4.19103 7.83995L5.23319 20.7265C5.29126 21.4459 5.89131 22 6.61222 22H15.4012C16.1221 22 16.7221 21.4459 16.7802 20.7264L17.8224 7.83995C17.8501 7.49939 17.5812 7.20801 17.2396 7.20801ZM7.79235 20.6255C7.77841 20.6263 7.76448 20.6268 7.75072 20.6268C7.40261 20.6268 7.11038 20.3558 7.08873 20.0036L6.43564 9.42442C6.41315 9.05835 6.69161 8.7433 7.05751 8.72081C7.42224 8.69865 7.73863 8.97644 7.76113 9.34268L8.41405 19.9219C8.43671 20.288 8.15825 20.6028 7.79235 20.6255ZM11.6782 19.9628C11.6782 20.3294 11.3809 20.6267 11.0142 20.6267C10.6474 20.6267 10.3502 20.3294 10.3502 19.9628V9.38347C10.3502 9.01672 10.6474 8.71947 11.0142 8.71947C11.3807 8.71947 11.6782 9.01672 11.6782 9.38347V19.9628ZM15.5779 9.42258L14.9544 20.0018C14.9337 20.3546 14.641 20.6267 14.2922 20.6267C14.2791 20.6267 14.2659 20.6263 14.2526 20.6257C13.8865 20.604 13.6072 20.2898 13.6289 19.9237L14.2523 9.34436C14.2737 8.97829 14.5869 8.69899 14.954 8.72064C15.3201 8.74213 15.5994 9.0565 15.5779 9.42258Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5357 5.15891L19.0996 3.85172C18.9846 3.50713 18.662 3.27466 18.2986 3.27466H3.71459C3.35137 3.27466 3.0286 3.50713 2.9138 3.85172L2.47773 5.15891C2.39364 5.41101 2.50307 5.66815 2.70734 5.79639C2.7906 5.84859 2.88912 5.87997 2.99738 5.87997H19.016C19.1243 5.87997 19.223 5.84859 19.306 5.79622C19.5103 5.66798 19.6197 5.41084 19.5357 5.15891Z",
  fill: "white"
});

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.2dc94895.svg";
export { ForwardRef as ReactComponent };